import AbsModal from './AbsModal';
import {makeElement} from '../../common/Utils';

export default class Modal extends AbsModal{    

    constructor(_options={}){
        super();
        this.type = AbsModal.TYPE_MODAL;
        this.optionsSetting(_options);
        this.makeBackdropEl();
        this.makeModalEl();
        this.setBtns();
        this.addEvents();
    }

    template(): string{      

        const temp = makeElement(super.template());       

        const closeBtnTmpl = makeElement( `
        <button type="button" class="nc-modal__close">
            <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <path d="m1.238 0.238 19.145 19.145m-19.145 0 9.549-9.55 7.398-7.397 2.198-2.198"></path>
                </g>
            </svg>
        </button>` );       

        
        const footerBtnTmpl = makeElement( `
        <div>
            <button type="button" class="nc-modal__btn nc-modal__btn--pri">
                <span class="nc-modal__btn-text">${this.options.primaryBtnText}</span>
            </button>
            <button type="button" class="nc-modal__btn nc-modal__btn--sec">
                <span class="nc-modal__btn-text">${this.options.cancelBtnText}</span>
            </button>
        </div>` );           
             

        temp.querySelector('.nc-modal__header')?.appendChild(closeBtnTmpl);
        temp.querySelector('.nc-modal__footer')?.appendChild(footerBtnTmpl);      
        
        
        const result = temp as unknown as string;           
        return result;        
    }
} // end of class